import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles'
import DrawerCustom from '../../components/DrawerCustom';
import { Grid } from '@material-ui/core';
import CustomTypo from '../../components/CustomTypo';
import { dataUtil } from '../../wsclient/crmservices/dataUtil';
import { formatTimeFrEpoch } from '../../utils/util';
import {HourglassIcon} from '../../components/icons'
import ButtonCustom from '../../components/ButtonCustom';
const styles = theme => ({
    container: {
        padding: theme.spacing(6,4,4,4)
    },
    boxItemContent: {
        padding: theme.spacing(4),
        marginTop: theme.spacing(1.5),
        marginBottom: theme.spacing(1.5),
        border: '1px solid',
        borderColor: theme.palette.border.transparent,
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(4),
        boxShadow: '1px 2px 10px -6px rgba(0,0,0,0.75)',
    },
    item: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        //borderBottomColor: variable.main_color.border_color.primary,
        paddingTop: 12,
        paddingBottom: 12,
        borderBottomWidth: 1,
        flexDirection: 'row'
    },
    item_creatives:{
        width: '15%', 
        marginRight: '1%', 
        marginLeft: '1%', 
        justifyContent: 'center', 
        alignItems: 'center'
    },
    cart_item_bg: {
        width: 40,
        height: 40,
        borderRadius: 40,
        //backgroundColor: variable.main_color.icon_color.bg_icon_primary,
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: 4, marginRight: 4
    },
    cart_icon_bg: {
        width: 40, 
        borderRadius: 40, 
        height: 40
    },
    status:{
        marginLeft: theme.spacing(4),
        padding: theme.spacing(0, 2, 0, 2),
        border: '1px solid',
        borderRadius: theme.spacing(4),
        ...theme.palette.button.success,
    }
})

function MyOrderDetailView(props) {
    const getComponent = (items) =>{
        var componentStr = '';
        if(items){
            items.forEach(item => {
                componentStr = componentStr + item.name + ", ";
            });
        }

        if (componentStr) {
            componentStr = componentStr.substr(0, componentStr.length - 2);
        }
        return componentStr;
    }
    const getPriceComponent = (items) =>{
        var price = 0
        if(items){
            items.forEach(item => {
                price = price + item.sub_total
            });
        }

        return price
    }
    const {classes, t, order, currency} = props
    console.log('order======',order)
    var keyDates = order.key_dates;
    var order_type = order.supply_method;
    var stringsReady = order_type === 'DELIVERY' ? t('expected_delivery_time') : t('expected_pickup_time');
    if (keyDates) {
        var time_to_deliver = keyDates.estimated_fulfillement_in ? keyDates.estimated_fulfillement_in : "";
        if (time_to_deliver) {
            time_to_deliver = time_to_deliver + " " + (keyDates.estimated_fulfillment_UOT ? keyDates.estimated_fulfillment_UOT : "");
        }
        var estimateCompleted = order_type === 'DELIVERY' ? keyDates.estimated_fulfillement : keyDates.estimated_fulfillement;
        stringsReady = stringsReady + " " + formatTimeFrEpoch(estimateCompleted) + " (" + time_to_deliver + "S )"
    }
    // var address = order.fulfilled_by&&order.fulfilled_by.address&&order.fulfilled_by.address.address_line_1?order.fulfilled_by.address.address_line_1:null
    var address = order.fulfilled_by&&order.fulfilled_by.address ? order.fulfilled_by.address.address_line_1
    + (order.fulfilled_by.address.town_city ? ', ' + order.fulfilled_by.address.town_city : '')
    + (order.fulfilled_by.address.state_province_county ? ', ' + order.fulfilled_by.address.state_province_county : '')
    + (order.fulfilled_by.address.postal_code ? ', ' + order.fulfilled_by.address.postal_code : '')
    : ''
    var phone = order.fulfilled_by&&order.fulfilled_by.phone?order.fulfilled_by.phone: null
    return (
        <div>
            <DrawerCustom 
                enableBack
                open={props.open} 
                onClose={props.onClose}
                title = {t('Order Details')}
                children={
                    <Grid xs={12} item>
                        <Grid xs={12} item className={classes.boxItemContent}>
                            <Grid xs={12} item container alignItems='center'>
                                <CustomTypo variant='subtitle2'>Order {" "}{order.number}</CustomTypo>
                                {/* <CustomTypo variant='subtitle2' >{" "}{order.number}</CustomTypo> */}
                                <ButtonCustom className={classes.status} size="xs" color={"success"}>{dataUtil.getLCSName(order.life_cycle_state)}</ButtonCustom>
                                </Grid>
                            <Grid xs={12} item container>
                                <Grid xs={8} item>
                                    <CustomTypo variant='body2' color='description'>{order_type === 'DELIVERY' ? t('delivery_from') : t('take_away_from')}</CustomTypo>
                                    <CustomTypo variant='subtitle2'>{order_type === 'DELIVERY' && order.address ? order.address.address_line_1 : (order.fulfilled_by ? order.fulfilled_by.name : "")}</CustomTypo>
                                </Grid>
                                <Grid xs={4} item justify='flex-end'>
                                    {phone&&<CustomTypo variant='body2' color='description'>{t('phone_number')}:</CustomTypo>}
                                    {phone&&<CustomTypo variant='subtitle2'>{phone}</CustomTypo>}
                                </Grid>  
                            </Grid>
                            <Grid xs={12} item>
                                    {address&&<CustomTypo variant='body2' color='description'>{t('Address')}:</CustomTypo>}
                                    {address&&<CustomTypo variant='subtitle2'>{address}</CustomTypo>}
                                </Grid>  
                            <Grid xs={12} item container className={classes.item} alignItems='center'>
                                <HourglassIcon/>
                                <CustomTypo mg_top_xs mg_left_xs variant='body2' color='description'>{stringsReady}</CustomTypo> 
                            </Grid>
                            <hr/>
                            {order.order_items&&order.order_items.map((item,index)=>
                                <div>
                                    <Grid xs={12} item className={classes.item} container>
                                        <Grid xs={10} item container alignItems={item.components&&item.components.length>0?'center':'flex-start'}>
                                            {item.creatives && <Grid item className={classes.item_creatives}>
                                                <Grid className={classes.cart_item_bg}>
                                                    <CartItemImage creatives={item.creatives} classes={classes} />
                                                </Grid>
                                            </Grid>}
                                            <Grid item>
                                                <CustomTypo variant='subtitle1' >{item.quantity} x </CustomTypo>
                                            </Grid>
                                            <Grid item>
                                                <CustomTypo mg_left_md variant='subtitle1' >{item.product.name}</CustomTypo>
                                                {item.components ? <CustomTypo mg_left_md variant='description' color='description'>{getComponent(item.components)}</CustomTypo> : null}
                                            </Grid>
                                        </Grid>
                                        <Grid xs={2} item container justify='flex-end'>
                                            <CustomTypo variant='subtitle2' color='secondary'>{currency}{((item.product && item.product.price ? item.product.price : 0) * item.quantity+getPriceComponent(item.components)).toFixed(2)}</CustomTypo>
                                        </Grid>
                                        
                                    </Grid>
                                    <hr/>
                                </div>
                            )}    
                        </Grid>        
                    </Grid>
                }/>
        </div>
    );
}
function CartItemImage(props) {
    const {classes} = props
    var creatives = props.creatives;
    var imageURL = null;
    if (creatives && creatives.length > 0) {
        imageURL = creatives[0].url;
    }
    if (imageURL) {
        return <img src={imageURL} className={classes.cart_icon_bg} />
    } else {
        return null
    }
}
export default withStyles(styles)(withTranslation()(MyOrderDetailView));